import { useAuthStore } from '../stores/auth.store';
import { hasRole, hasAnyRole } from '../lib/keycloak';

export function useAuth() {
  const store = useAuthStore();

  return {
    ...store,
    hasRole,
    hasAnyRole,
    isSuperAdmin: hasRole('super_admin'),
    isAdmin: hasAnyRole(['super_admin', 'company_admin']),
    isManagerITC: hasAnyRole(['super_admin', 'company_admin', 'manager_itc']),
    isManagerTM: hasAnyRole(['super_admin', 'company_admin', 'manager_tm']),
  };
}
